import gql from 'graphql-tag';
import insurtechBasicFragments from './insurtech.basic.fragments';

const insurtechCommonFragments = {
    WeatherPromise: {
        Module: gql`
            fragment WeatherPromiseModuleFragment on InsurtechShoppingModule {
                __typename
                id
                heading {
                    ...InsurtechModuleHeadingFragment
                }
                content {
                    __typename
                    ...InsurTechCheckBoxWrapperFragment
                    ...InsurTechBenefitSectionFragment
                    ...InsurTechSelectionSectionFragment
                }
                metaInfo {
                    name
                    value
                }
                footer {
                    ...InsurtechShoppingModuleFooterFragment
                }
                messageInfo {
                    name
                    value
                }
            }
            ${insurtechBasicFragments.Heading}
            ${insurtechBasicFragments.FOOTER}
            ${insurtechBasicFragments.EGDSPlainText}
            ${insurtechBasicFragments.EGDSHeadingText}
            ${insurtechBasicFragments.CheckBoxWrapper}
            ${insurtechBasicFragments.IconFragment}
            ${insurtechBasicFragments.InsurtechPopover}
            ${insurtechBasicFragments.BenefitSection}
            ${insurtechBasicFragments.ClientSideAnalytics}
            ${insurtechBasicFragments.IllustrationFragment}
            ${insurtechBasicFragments.StandardLinkWrapper}
            ${insurtechBasicFragments.TextWrapperElement}
            ${insurtechBasicFragments.EGDSStylizedText}
            ${insurtechBasicFragments.GraphicStylizedText}
            ${insurtechBasicFragments.DialogTrigger}
            ${insurtechBasicFragments.SpannableText}
            ${insurtechBasicFragments.UpdateProductSelectionAction}
            ${insurtechBasicFragments.ClickableElement}
            ${insurtechBasicFragments.SelectionSection}
        `,
        Dialog: gql`
            fragment InsurtechDialogFragment on InsurtechDialog {
                dialogId
                dialog {
                    ... on EGDSFullScreenDialog {
                        closeAnalytics {
                            ...ClientSideAnalyticsFragment
                        }
                    }
                }
                dialogHeading {
                    ... on InsurtechBenefitDialogHeading {
                        header
                        graphic {
                            ...GraphicIllustrationFragment
                        }
                        viewType
                    }
                }
                dialogContent {
                    ...DialogContentFragment
                }
                dialogFooter {
                    ... on InsurtechActionDialogFooter {
                        actions {
                            ... on UIPrimaryButton {
                                primary
                                analytics {
                                    ...ClientSideAnalyticsFragment
                                }
                            }
                        }
                        additionalInfoSection {
                            ...InsurTechTextWrapperElementFragment
                        }
                    }
                }
            }
            fragment DialogContentFragment on InsurtechDialogContent {
                ... on InsurtechBenefitDialogContent {
                    benefitSection {
                        ...InsurTechBenefitSectionFragment
                    }
                    link {
                        ...EGDSStandardLinkFragment
                    }
                }
            }
            ${insurtechBasicFragments.EGDSStandardLink}
            ${insurtechBasicFragments.IllustrationFragment}
            ${insurtechBasicFragments.ClientSideAnalytics}
            ${insurtechBasicFragments.EGDSPlainText}
            ${insurtechBasicFragments.EGDSStylizedText}
            ${insurtechBasicFragments.GraphicStylizedText}
            ${insurtechBasicFragments.SpannableText}
            ${insurtechBasicFragments.TextWrapperElement}
            ${insurtechBasicFragments.IconFragment}
            ${insurtechBasicFragments.InsurtechPopover}
            ${insurtechBasicFragments.BenefitSection}
        `,
    },
    InsurtechShoppingModule: {
        Module: gql`
            fragment InsurtechShoppingModuleFragment on InsurtechShoppingModule {
                __typename
                id
                heading {
                    ...InsurtechModuleHeadingFragment
                }
                content {
                    __typename
                    ...InsurTechBenefitSectionFragment
                    ...InsurTechCheckBoxWrapperFragment
                    ...InsurTechTextWrapperFragment
                    ...InsurTechRadioGroupWrapperFragment
                    ...InsurtechMiscellaneousSectionFragment
                }
                footer {
                    __typename
                    ... on InsurtechShoppingModuleDisclaimerFooter {
                        disclaimer
                        content {
                            __typename
                            ...InsurtechSpannableTextFragment
                            ...InsurtechStandardLinkWrapperFragment
                        }
                    }
                }
                metaInfo {
                    name
                    value
                }
                urgencyMessage {
                    ...InsurtechUrgencySectionFragment
                }
            }
            ${insurtechBasicFragments.Heading}
            ${insurtechBasicFragments.BenefitSection}
            ${insurtechBasicFragments.TextWrapperElement}
            ${insurtechBasicFragments.TextWrapper}
            ${insurtechBasicFragments.StandardLinkWrapper}
            ${insurtechBasicFragments.RadioGroupWrapper}
            ${insurtechBasicFragments.CheckBoxWrapper}
            ${insurtechBasicFragments.SpannableText}
            ${insurtechBasicFragments.GraphicStylizedText}
            ${insurtechBasicFragments.EGDSStylizedText}
            ${insurtechBasicFragments.DialogTrigger}
            ${insurtechBasicFragments.EGDSStandardLink}
            ${insurtechBasicFragments.IllustrationFragment}
            ${insurtechBasicFragments.IconFragment}
            ${insurtechBasicFragments.InsurtechPopover}
            ${insurtechBasicFragments.ClientSideAnalytics}
            ${insurtechBasicFragments.EGDSPlainText}
            ${insurtechBasicFragments.EGDSHeadingText}
            ${insurtechBasicFragments.UpdateProductSelectionAction}
            ${insurtechBasicFragments.UrgencyMessageFragment}
            ${insurtechBasicFragments.InsurtechMiscellaneousSection}
        `,
    },
};

export default insurtechCommonFragments;
